(() => {
  const benefits = [
    {
      title: 'Adjustable Fit',
      text: 'Set the compression to the fit that feels right for you.',
      icon: 'sliders-horizontal'
    },
    {
      title: 'Low-Bulk Design',
      text: 'Designed for active movement without a bulky brace feel.',
      icon: 'minimize-2'
    },
    {
      title: 'Comfortable Support',
      text: 'Flexible support for walks, workouts, sports, and daily activity.',
      icon: 'activity'
    },
    {
      title: 'Easy to Wear',
      text: 'Simple to put on when you want extra ankle support.',
      icon: 'check-circle-2'
    }
  ];

  const isMovaraProduct = () => {
    const metaHandle = window.meta?.product?.handle;
    return metaHandle === 'coolza-movara' || window.location.pathname === '/products/coolza-movara';
  };

  const rewriteConfidenceSection = () => {
    if (!isMovaraProduct()) return;

    const section =
      document.querySelector('#MainContent [id$="__section_1768921544234_ni6sp8ggz"]') ||
      Array.from(document.querySelectorAll('#MainContent .pagepilot-section')).find((candidate) =>
        candidate.textContent.includes('Moving with ease and true confidence')
      );

    if (!section || section.dataset.czMovaraConfidenceEnhanced === 'true') return;

    const originalImage = section.querySelector('img.pp-image') || section.querySelector('img');
    const image = originalImage ? originalImage.cloneNode(true) : document.createElement('img');

    if (!originalImage) {
      image.src = '//coolza.us/cdn/shop/files/1787290156787-w6jyj2ushab-1787290520328-ajoresge.webp?v=1787290522&width=1000';
      image.width = 1000;
      image.height = 1000;
    }

    image.className = 'cz-movara-confidence__image';
    image.alt = image.alt || 'CoolZa Movara worn during everyday movement';
    image.removeAttribute('style');
    image.removeAttribute('loading');

    const confidenceCards = [
      {
        title: 'Easy On',
        text: 'Slip it on when you want extra support for daily movement.',
        icon: 'footprints'
      },
      {
        title: 'Adjustable Feel',
        text: 'Set the wrap to the compression that feels right for you.',
        icon: 'sliders-horizontal'
      },
      {
        title: 'Low-Bulk Comfort',
        text: 'Made to fit under socks and shoes without a heavy brace feel.',
        icon: 'move'
      }
    ];

    const replacement = document.createElement('section');
    replacement.className = 'cz-movara-confidence';
    replacement.setAttribute('aria-labelledby', 'cz-movara-confidence-title');
    replacement.innerHTML = `
      <div class="cz-movara-confidence__inner">
        <div class="cz-movara-confidence__media"></div>
        <div class="cz-movara-confidence__content">
          <p class="cz-movara-confidence__eyebrow">Everyday support</p>
          <h2 class="cz-movara-confidence__title" id="cz-movara-confidence-title">Move Comfortably, Every Day</h2>
          <p class="cz-movara-confidence__text">Movara gives you soft, low-bulk ankle support for walks, workouts, errands, and daily activity.</p>
          <div class="cz-movara-confidence__cards"></div>
          <p class="cz-movara-confidence__note">Comfort and fit can vary by person. Adjust the wrap to what feels best for you.</p>
        </div>
      </div>
    `;

    replacement.querySelector('.cz-movara-confidence__media').append(image);
    const cards = replacement.querySelector('.cz-movara-confidence__cards');

    confidenceCards.forEach(({ title, text, icon }) => {
      const card = document.createElement('article');
      card.className = 'cz-movara-confidence__card';
      card.innerHTML = `
        <span class="cz-movara-confidence__icon" aria-hidden="true"><i data-lucide="${icon}"></i></span>
        <h3>${title}</h3>
        <p>${text}</p>
      `;
      cards.append(card);
    });

    section.replaceChildren(replacement);
    section.dataset.czMovaraConfidenceEnhanced = 'true';
    window.lucide?.createIcons?.();
  };

  const rewriteStepSection = () => {
    if (!isMovaraProduct()) return;

    const section =
      document.querySelector('#MainContent [id$="__pagepilot_blank_4Nz2hp"]') ||
      Array.from(document.querySelectorAll('#MainContent .pagepilot-section')).find((candidate) =>
        candidate.textContent.includes('Step into your confidence today')
      );

    if (!section || section.dataset.czMovaraStepEnhanced === 'true') return;

    const originalImage = section.querySelector('img.pp-image') || section.querySelector('img');
    const image = originalImage ? originalImage.cloneNode(true) : document.createElement('img');

    if (!originalImage) {
      image.src = '//coolza.us/cdn/shop/files/1787290460921-73ywxgrsaai-1787290520328-wnap2uv0.webp?v=1787290522&width=1000';
      image.width = 1000;
      image.height = 1000;
    }

    image.className = 'cz-movara-step__image';
    image.alt = image.alt || 'CoolZa Movara ankle support design details';
    image.removeAttribute('style');
    image.removeAttribute('loading');

    const callouts = [
      {
        label: 'Breathable and absorbent fabric',
        position: 'top-right'
      },
      {
        label: 'Honeycomb compression',
        position: 'mid-right'
      },
      {
        label: 'Power Velcro',
        position: 'mid-left'
      },
      {
        label: 'High elastic skin friendly fabric',
        position: 'bottom-left'
      },
      {
        label: 'Open back heel',
        position: 'bottom-right'
      }
    ];

    const rows = [
      {
        number: '92%',
        title: 'Felt More Comfortable During Long Days',
        text: 'Customers reported improved comfort and reduced ankle fatigue during extended wear.'
      },
      {
        number: '87%',
        title: 'Felt More Confident in Movement',
        text: 'Wearers felt supported and stable during training, lifting, and everyday activity.'
      },
      {
        number: '94%',
        title: 'Comfortable All-Day Fit',
        text: 'Customers comforted wearing Ortho Motion&trade; inside shoes without bulk or irritation.'
      }
    ];

    const replacement = document.createElement('section');
    replacement.className = 'cz-movara-step';
    replacement.setAttribute('aria-labelledby', 'cz-movara-step-title');
    replacement.innerHTML = `
      <div class="cz-movara-step__inner">
        <div class="cz-movara-step__header">
          <p class="cz-movara-step__eyebrow">CoolZa fit details</p>
          <h2 class="cz-movara-step__title" id="cz-movara-step-title">Step Into Support That Moves With You</h2>
          <p class="cz-movara-step__subtitle">A closer look at the soft, adjustable details that make Movara easy to wear every day.</p>
        </div>
        <div class="cz-movara-step__layout">
          <div class="cz-movara-step__visual">
            <div class="cz-movara-step__image-wrap"></div>
            <div class="cz-movara-step__callouts"></div>
          </div>
          <div class="cz-movara-step__rows"></div>
        </div>
      </div>
    `;

    replacement.querySelector('.cz-movara-step__image-wrap').append(image);

    const calloutsContainer = replacement.querySelector('.cz-movara-step__callouts');
    callouts.forEach(({ label, position }) => {
      const callout = document.createElement('span');
      callout.className = `cz-movara-step__callout cz-movara-step__callout--${position}`;
      callout.textContent = label;
      calloutsContainer.append(callout);
    });

    const rowsContainer = replacement.querySelector('.cz-movara-step__rows');
    rows.forEach(({ number, title, text }) => {
      const row = document.createElement('article');
      row.className = 'cz-movara-step__row';
      row.innerHTML = `
        <span class="cz-movara-step__number">${number}</span>
        <div>
          <h3>${title}</h3>
          <p>${text}</p>
        </div>
      `;
      rowsContainer.append(row);
    });

    const cta = document.createElement('button');
    cta.className = 'cz-movara-step__cta';
    cta.type = 'button';
    cta.textContent = 'Get Yours Now';
    cta.addEventListener('click', () => {
      const target = document.querySelector('.pp-product-information') || document.querySelector('[data-product-form]');
      target?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    rowsContainer.append(cta);

    section.replaceChildren(replacement);
    section.dataset.czMovaraStepEnhanced = 'true';
  };

  const findTargetSection = () => {
    const exact = document.querySelector('#MainContent [id$="__pagepilot_blank_HnXeSN"]');
    if (exact && exact.textContent.includes('Move with ease and total confidence')) return exact;

    return Array.from(document.querySelectorAll('#MainContent .pagepilot-section')).find((section) =>
      section.textContent.includes('Move with ease and total confidence')
    );
  };

  const faqItems = [
    {
      question: 'Who is Movara for?',
      answer: 'Movara is made for everyday movement when you want extra ankle support without a bulky brace feel. If you are dealing with an injury, ongoing pain, or a medical condition, check with a qualified professional before use.'
    },
    {
      question: 'How do I put it on?',
      answer: 'Slide your foot through the sleeve, position it comfortably around your ankle, then adjust the strap until it feels secure. It should feel snug and steady, not tight or restrictive.'
    },
    {
      question: 'Can I wear it with shoes?',
      answer: 'Yes. The low-bulk design is made to fit inside most everyday shoes. If your shoe feels tight, loosen the wrap slightly or choose a roomier pair.'
    },
    {
      question: 'When should I wear it?',
      answer: 'Wear it when you want a little extra support for walks, errands, light workouts, sports, or daily activity. Adjust the fit based on what feels comfortable for you.'
    },
    {
      question: 'How should I clean it?',
      answer: 'Hand wash gently with cold water and mild soap, then air dry completely before wearing again. Avoid bleach, ironing, and high heat.'
    },
    {
      question: 'What about shipping and returns?',
      answer: 'Your order ships directly to your door, and CoolZa support is here if something is not right. Check the store policy links for current shipping times and return details.'
    }
  ];

  const reviewItems = [
    {
      author: 'Sarah',
      context: 'Daily walks',
      stars: 5,
      imageIndex: 0,
      text: 'Light enough for my sneakers and easy to adjust before longer walks.'
    },
    {
      author: 'Marcus',
      context: 'Light workouts',
      stars: 5,
      imageIndex: 1,
      featured: true,
      text: 'The strap lets me make it snug for workouts, then loosen it after.'
    },
    {
      author: 'Elena',
      context: 'Work shoes',
      stars: 4,
      imageIndex: 2,
      text: 'Took a try to get the fit right, but it sits comfortably in my work shoes.'
    },
    {
      author: 'Jessica',
      context: 'Busy days',
      stars: 5,
      imageIndex: 3,
      text: 'Good for days when I am on my feet a lot. Soft, low-bulk, and secure.'
    },
    {
      author: 'David',
      context: 'Errands',
      stars: 5,
      imageIndex: 4,
      text: 'Low-profile enough for daily shoes and easy to wear around town.'
    },
    {
      author: 'Nina',
      context: 'Gym sessions',
      stars: 5,
      imageIndex: 5,
      text: 'Feels secure during training and does not add much bulk in my shoes.'
    },
    {
      author: 'Chris',
      context: 'Weekend sports',
      stars: 5,
      imageIndex: 6,
      text: 'Easy to put on before a game and simple to adjust when I need it.'
    },
    {
      author: 'Amelia',
      context: 'Long shifts',
      stars: 4,
      imageIndex: 7,
      text: 'Comfortable for busy days, and the wrap stays in place once fitted.'
    }
  ];

  const makeStars = (rating) =>
    Array.from({ length: 5 }, (_, index) => {
      const emptyClass = index < rating ? '' : ' cz-movara-reviews__star--empty';
      return `<i data-lucide="star" class="cz-movara-reviews__star${emptyClass}"></i>`;
    }).join('');

  const rewriteFaqSection = () => {
    if (!isMovaraProduct()) return;

    const section =
      document.querySelector('#MainContent [id$="__pagepilot_blank_GtZ4le"]') ||
      Array.from(document.querySelectorAll('#MainContent .pagepilot-section')).find((candidate) =>
        candidate.textContent.includes('Frequently Asked Questions')
      );

    if (!section || section.dataset.czMovaraFaqEnhanced === 'true') return;

    const replacement = document.createElement('section');
    replacement.className = 'cz-movara-faq';
    replacement.setAttribute('aria-labelledby', 'cz-movara-faq-title');
    replacement.innerHTML = `
      <div class="cz-movara-faq__inner">
        <div class="cz-movara-faq__header">
          <p class="cz-movara-faq__eyebrow">Quick answers</p>
          <h2 class="cz-movara-faq__title" id="cz-movara-faq-title">Frequently Asked Questions</h2>
          <p class="cz-movara-faq__subtitle">Everything you need to know about fit, wear, care, and orders.</p>
        </div>
        <div class="cz-movara-faq__list"></div>
      </div>
    `;

    const list = replacement.querySelector('.cz-movara-faq__list');
    faqItems.forEach(({ question, answer }, index) => {
      const item = document.createElement('details');
      item.className = 'cz-movara-faq__item';
      if (index === 0) item.open = true;
      item.innerHTML = `
        <summary class="cz-movara-faq__question">
          <span>${question}</span>
          <span class="cz-movara-faq__icon" aria-hidden="true"><i data-lucide="chevron-down"></i></span>
        </summary>
        <div class="cz-movara-faq__answer">
          <p>${answer}</p>
        </div>
      `;
      list.append(item);
    });

    section.replaceChildren(replacement);
    section.dataset.czMovaraFaqEnhanced = 'true';
    window.lucide?.createIcons?.();
  };

  const cloneReviewImage = (source, alt) => {
    if (!source) return null;
    const image = source.cloneNode(true);
    image.className = 'cz-movara-reviews__photo';
    image.alt = alt;
    image.removeAttribute('style');
    image.removeAttribute('loading');
    return image;
  };

  const rewriteReviewsSection = () => {
    if (!isMovaraProduct()) return;

    const section =
      document.querySelector('#MainContent [id$="__pagepilot_blank_5VfLPz"]') ||
      Array.from(document.querySelectorAll('#MainContent .pagepilot-section')).find((candidate) =>
        candidate.textContent.includes('What Our Community Says')
      );

    if (!section || section.dataset.czMovaraReviewsEnhanced === 'true') return;

    const originalImages = Array.from(section.querySelectorAll('img.pp-image, img')).filter((image) => image.src);
    const replacement = document.createElement('section');
    replacement.className = 'cz-movara-reviews';
    replacement.setAttribute('aria-labelledby', 'cz-movara-reviews-title');
    replacement.innerHTML = `
      <div class="cz-movara-reviews__inner">
        <div class="cz-movara-reviews__header">
          <h2 class="cz-movara-reviews__title" id="cz-movara-reviews-title">Trusted by Active People</h2>
          <div class="cz-movara-reviews__rating" aria-label="4.8 out of 5 stars from 1,016 reviews">
            <span class="cz-movara-reviews__rating-stars" aria-hidden="true">
              <i data-lucide="star"></i><i data-lucide="star"></i><i data-lucide="star"></i><i data-lucide="star"></i><i data-lucide="star"></i>
            </span>
            <strong>4.8</strong>
            <span class="cz-movara-reviews__rating-divider" aria-hidden="true"></span>
            <em>1,016 Reviews</em>
          </div>
        </div>
        <div class="cz-movara-reviews__carousel">
          <button class="cz-movara-reviews__nav cz-movara-reviews__nav--prev" type="button" aria-label="Previous review">
            <i data-lucide="chevron-left"></i>
          </button>
          <div class="cz-movara-reviews__viewport">
            <div class="cz-movara-reviews__grid"></div>
          </div>
          <button class="cz-movara-reviews__nav cz-movara-reviews__nav--next" type="button" aria-label="Next review">
            <i data-lucide="chevron-right"></i>
          </button>
        </div>
        <p class="cz-movara-reviews__note">Individual experiences can vary. Adjust Movara to the fit that feels comfortable for you.</p>
      </div>
    `;

    const grid = replacement.querySelector('.cz-movara-reviews__grid');
    const createReviewCard = ({ author, context, stars, imageIndex, featured, text }) => {
      const card = document.createElement('article');
      card.className = `cz-movara-reviews__card${featured ? ' cz-movara-reviews__card--featured' : ''}`;
      card.innerHTML = `
        <div class="cz-movara-reviews__photo-wrap"></div>
        <div class="cz-movara-reviews__body">
          <div class="cz-movara-reviews__stars" aria-label="${stars} out of 5 stars">${makeStars(stars)}</div>
          <p class="cz-movara-reviews__quote">${text}</p>
          <div class="cz-movara-reviews__meta">
            <span class="cz-movara-reviews__avatar" aria-hidden="true">${author.charAt(0)}</span>
            <span>
              <strong>${author}</strong>
              <small>${context}</small>
            </span>
          </div>
        </div>
      `;

      const imageSource = originalImages.length ? originalImages[imageIndex % originalImages.length] : null;
      const image = cloneReviewImage(imageSource, `${author} review image`);
      const imageWrap = card.querySelector('.cz-movara-reviews__photo-wrap');
      if (image) {
        imageWrap.append(image);
      } else {
        imageWrap.remove();
      }

      return card;
    };

    reviewItems.forEach((review) => {
      grid.append(createReviewCard(review));
    });

    const viewport = replacement.querySelector('.cz-movara-reviews__viewport');

    const centerCard = (card, behavior = 'auto') => {
      if (!viewport || !card) return;
      viewport.scrollTo({
        left: Math.max(0, card.offsetLeft - ((viewport.clientWidth - card.offsetWidth) / 2)),
        behavior
      });
    };

    const scrollReviews = (direction) => {
      viewport.scrollBy({
        left: direction * Math.min(viewport.clientWidth * 0.86, 520),
        behavior: 'smooth'
      });
    };

    replacement.querySelector('.cz-movara-reviews__nav--prev')?.addEventListener('click', () => {
      scrollReviews(-1);
    });
    replacement.querySelector('.cz-movara-reviews__nav--next')?.addEventListener('click', () => {
      scrollReviews(1);
    });
    window.addEventListener('resize', () => {
      centerCard(grid.querySelector('.cz-movara-reviews__card--featured'));
    });

    section.replaceChildren(replacement);
    section.dataset.czMovaraReviewsEnhanced = 'true';
    window.lucide?.createIcons?.();

    window.requestAnimationFrame(() => {
      centerCard(grid.querySelector('.cz-movara-reviews__card--featured'));
    });
  };

  const makeBenefitCard = ({ title, text, icon }) => {
    const card = document.createElement('article');
    card.className = 'cz-movara-benefits__card';
    card.innerHTML = `
      <span class="cz-movara-benefits__icon" aria-hidden="true"><i data-lucide="${icon}"></i></span>
      <div>
        <h3>${title}</h3>
        <p>${text}</p>
      </div>
    `;
    return card;
  };

  const enhanceBenefits = () => {
    if (!isMovaraProduct()) return;

    const section = findTargetSection();
    if (!section || section.dataset.czMovaraBenefitsEnhanced === 'true') return;

    const originalImage = section.querySelector('img.pp-image') || section.querySelector('img');
    const image = originalImage ? originalImage.cloneNode(true) : document.createElement('img');

    if (!originalImage) {
      image.src = '//coolza.us/cdn/shop/files/1787290285548-aidp1mlb7w-1787290520328-7geevcrs.webp?v=1787290522&width=1000';
      image.width = 1000;
      image.height = 1000;
    }

    image.className = 'cz-movara-benefits__image';
    image.alt = image.alt || 'CoolZa Movara ankle support in use';
    image.removeAttribute('style');
    image.removeAttribute('loading');

    const leftCards = document.createElement('div');
    leftCards.className = 'cz-movara-benefits__cards cz-movara-benefits__cards--left';
    benefits.slice(0, 2).forEach((benefit) => leftCards.append(makeBenefitCard(benefit)));

    const rightCards = document.createElement('div');
    rightCards.className = 'cz-movara-benefits__cards cz-movara-benefits__cards--right';
    benefits.slice(2).forEach((benefit) => rightCards.append(makeBenefitCard(benefit)));

    const media = document.createElement('div');
    media.className = 'cz-movara-benefits__media';
    media.append(image);

    const tag = document.createElement('span');
    tag.className = 'cz-movara-benefits__tag';
    tag.textContent = 'Low-bulk everyday support';
    media.append(tag);

    const replacement = document.createElement('section');
    replacement.className = 'cz-movara-benefits';
    replacement.setAttribute('aria-labelledby', 'cz-movara-benefits-title');
    replacement.innerHTML = `
      <div class="cz-movara-benefits__inner">
        <div class="cz-movara-benefits__header">
          <p class="cz-movara-benefits__eyebrow">Everyday movement</p>
          <h2 class="cz-movara-benefits__title" id="cz-movara-benefits-title">Made to Move With You</h2>
          <p class="cz-movara-benefits__subtitle">Comfortable, low-bulk support designed for everyday movement.</p>
        </div>
        <div class="cz-movara-benefits__layout"></div>
      </div>
    `;

    replacement.querySelector('.cz-movara-benefits__layout').append(leftCards, media, rightCards);
    section.replaceChildren(replacement);
    section.dataset.czMovaraBenefitsEnhanced = 'true';

    window.lucide?.createIcons?.();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      rewriteConfidenceSection();
      rewriteStepSection();
      enhanceBenefits();
      rewriteFaqSection();
      rewriteReviewsSection();
    }, { once: true });
  } else {
    rewriteConfidenceSection();
    rewriteStepSection();
    enhanceBenefits();
    rewriteFaqSection();
    rewriteReviewsSection();
  }

  document.addEventListener('shopify:section:load', () => {
    rewriteConfidenceSection();
    rewriteStepSection();
    enhanceBenefits();
    rewriteFaqSection();
    rewriteReviewsSection();
  });
})();
